<template>
  <md-table
    v-loading="loading"
    :data="listData"
  >
    <md-table-column
      type="index"
      label="序号"
      min-width="50"
    />
    <md-table-column
      prop="name"
      label="参数名称"
      min-width="120"
    />
    <md-table-column
      prop="cmdCodeUp"
      label="上行控制"
      min-width="80"
    />
    <md-table-column
      prop="cmdCode"
      label="下行控制"
      min-width="80"
    />
    <md-table-column
      prop="description"
      label="参数说明"
      min-width="120"
    />
    <md-table-column
      prop="updateAt"
      label="更新时间"
      min-width="120"
    />
    <md-table-column
      prop="updatorName"
      label="更新人"
      min-width="100"
    />
    <md-table-column
      fixed="right"
      label="操作"
      min-width="130"
    >
      <template slot-scope="scope">
        <el-button
          v-if="$route.meta.btns && $route.meta.btns['0003']"
          type="primary"
          size="mini"
          @click="showEditDialog(1,scope.row)"
        >编辑</el-button>
        <el-button
          v-if="$route.meta.btns && $route.meta.btns['0004']"
          type="primary"
          size="mini"
          @click="deleteParams(scope.row)"
        >删除</el-button>
        <el-button
          v-if="$route.meta.btns && $route.meta.btns['0005']"
          type="primary"
          size="mini"
          @click="showDetailDialog(scope.row)"
        >详情</el-button>

      </template>
    </md-table-column>
  </md-table>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    listData: { type: Array },
    showEditDialog: { type: Function },
    showDetailDialog: { type: Function },
    deleteParams: { type: Function },
  },
  computed: {
    ...mapGetters(['loading']),
  },
};
</script>
